import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Redirect } from "react-router-dom";
import { ROUTES } from "../../core/constants/Routes";

const LogoutCallback = () => {
  const auth = useAuth();

  useEffect(() => {
    localStorage.removeItem("auth-token");
    auth.removeUser();
  }, [auth]);

  return <Redirect to={ROUTES.INITIAL_ROUTE} />;
};

export default LogoutCallback;
